module.exports = __webpack_public_path__ + "70a5e84062ec88d05f33b0340e96106a.png";